






import {Component} from "vue-property-decorator"
import AbpBase from "../../../lib/abpbase"

@Component
export default class Blood extends AbpBase{
	year = new Date()
	loading = false
	columns = [
		{title:'患者姓名'},
		{title:'月透析次数'},
		{title:'血红蛋白(HB)'},
		{title:'干体重(kg)'},
		{title:"月促红素总用量(U)"},
		{title:"每周促红素用量(U)"},
		{title:"每周每公斤体重使用促红素(U/KG)"},
		{title:"使用详情"}
	]
	data = []
	getData(){
		this.loading = true
		setTimeout(()=>{
			this.loading = false
		},500)
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/report/redUse/index.vue